const ONE_MINUTE = 1000 * 60

export interface DataPollingOptions {
  skipInitialExec: boolean
  intervalDelay: number
}

class IDataPollingOptionsExtension {
  getPollingOptions(
    skipInitialExec = false,
    intervalDelay = ONE_MINUTE
  ): DataPollingOptions {
    return {
      skipInitialExec: skipInitialExec,
      intervalDelay: intervalDelay
    }
  }
}

export const IDataPollingOptions = new IDataPollingOptionsExtension()

/** Returns a mixin for interval based automatic data fetching (default: every second minute) */
export default (
  actionName,
  computedConditionNames,
  options: DataPollingOptions = IDataPollingOptions.getPollingOptions()
) => {
  const { intervalDelay = ONE_MINUTE, skipInitialExec = false } = options

  return {
    data() {
      return {
        loading: true
      }
    },
    computed: {
      shouldFetch() {
        if (!computedConditionNames.length) return true
        const conditions = computedConditionNames.map(name => this[name])
        return !conditions.includes(false)
      }
    },
    watch: {
      shouldFetch(isTrue) {
        if (isTrue) {
          this.startDataPolling()
        } else {
          this.stopDataPolling()
        }
      }
    },
    async created() {
      if (this.shouldFetch) {
        if (!skipInitialExec) await this[actionName]() // initial execution
        this.startDataPolling()
      }
      this.loading = false
    },
    mounted() {
      if (this.shouldFetch) {
        // This avoids continuous data fetching while tab is not active
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
      }
    },
    beforeDestroy() {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange, false)
      this.stopDataPolling()
    },
    methods: {
      startDataPolling() {
        this.loadInterval = setInterval(this[actionName], intervalDelay)
      },
      stopDataPolling() {
        clearInterval(this.loadInterval)
      },
      handleVisibilityChange() {
        if (document.hidden) {
          this.stopDataPolling()
        } else {
          this.startDataPolling()
        }
      }
    }
  }
}
